import { white } from '@kmns-internal/furikake/tokens'
import { Tab, Tabs, Typography } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import { useHistory } from 'react-router-dom'
import { Header } from 'src/components/header/Header'
import { useLimitedFeatureAvailability } from 'src/features/featureAvailability/useLimitedFeatureAvailability'

type ActiveTab = 'templates' | 'multipleChoiceSets' | 'traceKeys'

interface TemplateTabsHeaderProps {
  activeTab: ActiveTab
}

const TAB_ROUTES: Record<ActiveTab, string> = {
  templates: '/templates',
  multipleChoiceSets: '/multipleChoiceSets',
  traceKeys: '/traceKeys',
}

const TAB_TITLES: Record<ActiveTab, string> = {
  templates: 'ひな形',
  multipleChoiceSets: 'セット選択肢',
  traceKeys: '検索キー',
}

/**
 * ひな形・セット選択肢・検索キー共通のタブヘッダー
 * @param activeTab - 現在アクティブなタブ
 */
export const TemplateTabsHeader = ({ activeTab }: TemplateTabsHeaderProps) => {
  const history = useHistory()
  const { isFeatureAvailable } = useLimitedFeatureAvailability()

  return (
    <>
      <Header>
        <Typography variant="h6">ひな形</Typography>
        <Helmet>
          <title>{TAB_TITLES[activeTab]} | カミナシ レポート</title>
        </Helmet>
      </Header>

      <Tabs
        value={activeTab}
        onChange={(_, value: ActiveTab) => history.push(TAB_ROUTES[value])}
        sx={{ backgroundColor: white }}
      >
        <Tab label="ひな形" value="templates" />
        <Tab label="セット選択肢" value="multipleChoiceSets" />
        {isFeatureAvailable('reportTrace') && (
          <Tab label="検索キー" value="traceKeys" />
        )}
      </Tabs>
    </>
  )
}
